import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from '../../../model/project/project';
import { Subject } from 'rxjs';
import PMSColor from 'src/app/model/company/pmscolor';
import Company from 'src/app/model/company/company';
import Board from 'src/app/model/product/board/board';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { PRODUCT_FACTORIES } from 'src/app/helpers/product-helper';

@Component({
  selector: 'board-form',
  templateUrl: './board-form.component.html',
  styleUrls: ['./board-form.component.scss'],
})
export class BoardFormComponent implements OnInit {
  @Input()
  public inputProject: Project;

  @Input()
  public inputProduct: Board;

  @Input()
  public involvedCompanies: Company[];

  @Input()
  public pmsColorAdded: Subject<PMSColor>;

  @Input()
  public client = false;

  @Input()
  public fromOldSystem = false;

  @Input()
  public disabled = false;

  @Output()
  public outputBoard = new EventEmitter<Board>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  ngOnInit() {
    if (this.inputProduct.boardParts == null) {
      this.inputProduct.boardParts = [];
      this.inputProduct.boardParts.push(
        PRODUCT_FACTORIES.BOARD_FACTORY.createBoardPart()
      );
    } else if (this.inputProduct.boardParts.length < 1) {
      this.inputProduct.boardParts.push(
        PRODUCT_FACTORIES.BOARD_FACTORY.createBoardPart()
      );
    }
  }

  addBoardPart() {
    this.inputProduct.boardParts.push(
      PRODUCT_FACTORIES.BOARD_FACTORY.createBoardPart()
    );
  }

  delete(index) {
    this.inputProduct.boardParts.splice(index, 1);
    this.projectDisplayObservableService
      .getProductPartDeletedSubscribable()
      .next();
    this.outputBoard.emit();
  }
}
